import React, { useEffect, useRef } from "react";
import { Offcanvas } from "bootstrap";

const FormDrawer = ({
  id,
  title,
  subtitle,
  onSubmit,
  loading = false,
  setLoading,
  isEdited = true,
  btnText = "Save & Proceed",
  processingText = "Processing",
  children,
  closeBtnRef,
  width = "540px",
  hideFooter = false,
  footer = null,
}) => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit?.(e);
  };

  useEffect(() => {
    const el = document.getElementById(id);
    if (!el) return;

    const handleHide = () => {
      // Fade out backdrop immediately in sync with drawer sliding out
      document.querySelectorAll(".offcanvas-backdrop").forEach((b) => {
        b.classList.remove("show");
      });
    };

    const removeStaleBackdrop = () => {
      // Only clean up if no offcanvas is actually open or showing
      if (document.querySelector(".offcanvas.show, .offcanvas.showing")) return;
      document.querySelectorAll(".offcanvas-backdrop").forEach((b) => b.remove());
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };

    el.addEventListener("hide.bs.offcanvas", handleHide);
    el.addEventListener("hidden.bs.offcanvas", removeStaleBackdrop);

    return () => {
      el.removeEventListener("hide.bs.offcanvas", handleHide);
      el.removeEventListener("hidden.bs.offcanvas", removeStaleBackdrop);
      if (!document.querySelector(".offcanvas.show, .offcanvas.showing")) {
        document.querySelectorAll(".offcanvas-backdrop").forEach((b) => b.remove());
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
      }
    };
  }, [id]);

  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id={id}
      data-bs-backdrop="true"
      data-bs-scroll="false"
      aria-labelledby={`${id}Label`}
      style={{
        width: width,
        maxWidth: "100vw",
        zIndex: 1055,
      }}
    >
      <div className="offcanvas-header border-bottom px-4 py-3 bg-white">
        <div>
          {title && (
            <h5 className="offcanvas-title fw-bold m-0 text-dark" id={`${id}Label`}>
              {title}
            </h5>
          )}
          {subtitle && (
            <small className="text-muted d-block mt-1">
              {subtitle}
            </small>
          )}
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          ref={closeBtnRef}
        />
      </div>

      <div className="offcanvas-body p-4 d-flex flex-column">
        <form onSubmit={handleSubmit} className="d-flex flex-column h-100 justify-content-between">
          <div className="flex-grow-1">
            {children}
          </div>

          {!hideFooter && (
            <div className="pt-4 pb-2 mt-4 border-top">
              {footer ? (
                footer
              ) : (
                <button
                  type="submit"
                  className="primary__btn confirm-walletBtn w-100"
                  disabled={loading || !isEdited}
                >
                  {loading ? (
                    <div className="spinner-border spinner-border-sm text-light" role="status">
                      <span className="visually-hidden">
                        {processingText}...
                      </span>
                    </div>
                  ) : (
                    btnText
                  )}
                </button>
              )}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default FormDrawer;
